
//FETCH CHAPTERS
export const FETCH_ATTENDANCE_REQUEST = "FETCH_ATTENDANCE_REQUEST";
export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
export const FETCH_ATTENDANCE_FAILURE = "FETCH_ATTENDANCE_FAILURE";


